import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import Select, { components } from "react-select";
import { useDispatch, useSelector } from "react-redux";
import { FaPlus } from "react-icons/fa";
import InputText from "../../common/Input/InputText";
import InputOnlyNumber from "../../common/Input/InputOnlyNumber";
import InputDate from "../../common/Input/InputDate";
import AddUpdateMedicineMasterModal from "../medicineMaster/addUpdateMedicineMaster";
import {
  getMedicineSlice,
  createMedicineSlice,
} from "../../../store/slices/medicineMasterSlice";
import { getAllSpecialization } from "../../../store/slices/specializationSlice";
import { getTaxSlice } from "../../../store/slices/taxSlice";

const AddUpdateMedicineMaster = ({
  modalVisible,
  setModalVisible,
  selectedAction,
  handleAddOrUpdatetock,
  medicineTypes,
  supplier,
  stockFormData,
  setStockFormData,
}) => {
  const dispatch = useDispatch();
  const { token } = useSelector((state) => state.auth);
  const { medicine } = useSelector((state) => state.medicineMaster);
  const { specializations } = useSelector((state) => state.specializations);
  

  const [showMedicineModal, setShowMedicineModal] = useState(false);
  const [medicineFormData, setMedicineFormData] = useState({});

  useEffect(() => {
    dispatch(getTaxSlice({ token }));
    dispatch(getMedicineSlice({ token }));
    dispatch(getAllSpecialization({ token }));
  }, [dispatch, token]);

  const handleFormData = (e) => {
    setStockFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSetMedicineTypeEdit = (selected) => {
    setStockFormData((prev) => ({
      ...prev,
      medicineType: selected.value,
      medicineTypeName: selected.label,
    }));
  };

  const handleSetSupplierEdit = (selected) => {
    setStockFormData((prev) => ({
      ...prev,
      supplier: selected.value,
      supplierName: selected.label,
    }));
  };

  const handleNameChange = (selectedOption) => {
    if (selectedOption?.value === "add_new") {
      setModalVisible(false);
      setShowMedicineModal(true);
    } else {
      const selectedMedicine = medicine.find(
        (m) => m.brandName === selectedOption.value,
      );
      if (selectedMedicine) {
        setStockFormData((prev) => ({
          ...prev,
          name: selectedMedicine.brandName,
          hsnCode: selectedMedicine.hsnCode || "",
          unit: selectedMedicine.packSize || "",
          medicineType: selectedMedicine?.medicineType?._id || "",
          medicineTypeName: selectedMedicine?.medicineType?.name || "",
          mrp: selectedMedicine.mrp || "",
        }));
      } else {
        setStockFormData((prev) => ({
          ...prev,
          name: selectedOption.value,
        }));
      }
    }
  };

  const handleAddNewMedicine = async (e) => {
    e.preventDefault();
    const response = await dispatch(
      createMedicineSlice({ ...medicineFormData, token }),
    );
    const newMedicine = response?.payload?.result?.list;
    if (newMedicine?._id) {
      setShowMedicineModal(false);
      setModalVisible(true);
      setMedicineFormData({});
      setStockFormData((prev) => ({
        ...prev,
        name: newMedicine?.brandName,
        unit: newMedicine.packSize || "",
        hsnCode: newMedicine.hsnCode || "",
        medicineType: newMedicine?.medicineType?._id || "",
        medicineTypeName: newMedicine?.medicineType?.name || "",
        mrp: newMedicine.mrp || "",
      }));
    }
  };

  const customOptions = medicine?.map((item) => ({
    value: item?.brandName,
    label: item?.brandName,
  }));

  const optionsWithAdd = [
    ...customOptions,
    { value: "add_new", label: "Add New", isAddNew: true },
  ];

  const CustomOption = (props) => {
    const { data, innerRef, innerProps } = props;
    if (data.isAddNew) {
      return (
        <div
          ref={innerRef}
          {...innerProps}
          className="d-flex align-items-center px-2 py-1 text-primary"
          style={{ cursor: "pointer" }}
        >
          <FaPlus className="me-2" />
          <span>Add New</span>
        </div>
      );
    }
    return <components.Option {...props} />;
  };

  return (
    <>
      <Modal
        centered
        show={modalVisible}
        onHide={() => setModalVisible(false)}
        size="lg"
      >
        <div className="modal-header">
          <h5 className="modal-title">
            {selectedAction === "Update" ? "Update Stock" : "Add Stock"}
          </h5>
          <button
            type="button"
            className="btn-close"
            onClick={() => setModalVisible(false)}
          ></button>
        </div>
        <div className="modal-body">
          <form onSubmit={handleAddOrUpdatetock}>
            <div className="row">
              <div className="col-xl-6">
                <label className="col-form-label">Name</label>
                <Select
                  name="name"
                  value={
                    stockFormData?.name
                      ? {
                          value: stockFormData?.name,
                          label: stockFormData?.name,
                        }
                      : null
                  }
                  placeholder="Select Name"
                  onChange={handleNameChange}
                  options={optionsWithAdd}
                  components={{ Option: CustomOption }}
                  filterOption={(option, input) => {
                    if (option?.data?.isAddNew) return true;
                    return option?.label
                      .toLowerCase()
                      .includes(input.toLowerCase());
                  }}
                />
              </div>
              <div className="col-xl-6">
                <InputText
                  label="Batch Number"
                  name="batchNumber"
                  value={stockFormData.batchNumber}
                  onChange={handleFormData}
                />
              </div>
              <div className="col-xl-6">
                <InputText
                  label="HSN Code"
                  name="hsnCode"
                  value={stockFormData.hsnCode}
                  onChange={handleFormData}
                />
              </div>
              <div className="col-xl-6">
                <label className="col-form-label">Supplier</label>
                <Select
                  name="supplier"
                  value={
                    stockFormData?.supplier
                      ? {
                          value: stockFormData?.supplier,
                          label: stockFormData?.supplierName,
                        }
                      : null
                  }
                  placeholder="Select Supplier"
                  onChange={handleSetSupplierEdit}
                  options={supplier?.map((item) => ({
                    value: item._id,
                    label: item.name,
                  }))}
                  isDisabled={selectedAction === "Update"}
                />
              </div>
              <div className="col-xl-6">
                <label className="col-form-label">Medicine Type</label>
                <Select
                  name="medicineType"
                  value={
                    stockFormData?.medicineType
                      ? {
                          value: stockFormData?.medicineType,
                          label: stockFormData?.medicineTypeName,
                        }
                      : null
                  }
                  placeholder="Select Medicine Type"
                  onChange={handleSetMedicineTypeEdit}
                  options={medicineTypes?.map((item) => ({
                    value: item?._id,
                    label: item?.name,
                  }))}
                  isDisabled={selectedAction === "Update"}
                />
              </div>
              <div className="col-xl-6">
                <InputOnlyNumber
                  label="Quantity"
                  name="quantity"
                  value={stockFormData.quantity}
                  onChange={handleFormData}
                />
              </div>
              <div className="col-xl-6">
                <InputText
                  label="Unit"
                  name="unit"
                  value={stockFormData.unit}
                  onChange={handleFormData}
                />
              </div>
              <div className="col-xl-6">
                <InputOnlyNumber
                  label="MRP"
                  name="mrp"
                  value={stockFormData.mrp}
                  onChange={handleFormData}
                />
              </div>
              <div className="col-xl-6">
                <InputOnlyNumber
                  label="Low Stock"
                  name="lowStock"
                  value={stockFormData.lowStock}
                  onChange={handleFormData}
                />
              </div>
              <div className="col-xl-6">
                <InputDate
                  label="Expiry Date"
                  placeholder="expiryDate"
                  name="expiryDate"
                  value={stockFormData.expiryDate}
                  onChange={handleFormData}
                />
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={() => setModalVisible(false)}
              >
                Close
              </button>
              <button type="submit" className="btn btn-primary">
                {selectedAction === "Update" ? "Update" : "Save"}
              </button>
            </div>
          </form>
        </div>
      </Modal>

      <AddUpdateMedicineMasterModal
        modalVisible={showMedicineModal}
        setModalVisible={setShowMedicineModal}
        selectedAction={"Add"}
        medicineType={medicineTypes}
        specializations={specializations}
        handleSetMedicineTypeEdit={(item) =>
          setMedicineFormData((prev) => ({
            ...prev,
            medicineType: item?.value,
            medicineTypeName: item?.label,
          }))
        }
        handleSetDepartmentEdit={(item) =>
          setMedicineFormData((prev) => ({
            ...prev,
            department: item?.value,
            departmentName: item?.label,
          }))
        }
        handleSetMedicineFormData={(e) =>
          setMedicineFormData((prev) => ({
            ...prev,
            [e.target.name]: e?.target?.value,
          }))
        }
        handleAddOrUpdateMedicine={handleAddNewMedicine}
        medicineFormData={medicineFormData}
      />
    </>
  );
};

export default AddUpdateMedicineMaster;
